import React from 'react';
import { Link } from 'react-router'
import $ from 'jquery'

let config = require('config');
let logo       = require('../images/logo_cabin.svg')
let logoMobile = require('../images/logo_cabin_mobile.svg')
let logoMenu   = require('../images/logo_cabin_w.svg')
let logoScrolled = require('../images/logo_cabin_scrolled.svg')
let backArrow = require('../images/back_arrow.svg')

var lastPath = ""
var lastId = ""

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen:false,
      isMobile:false,
      isScrolled:false
    }
    this.openMenu  = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidMount() {
    $(window).on("resize", this.resize.bind(this))
    this.resize()
    $(window).on("scroll", this.scroll.bind(this))
    this.scroll()
  }

  componentWillUnmount() {
    $(window).off("resize")
    $(window).off("scroll")
  }

  openMenu() {
    this.setState({
      isMenuOpen:true
    })
    return
  }

  closeMenu() {
    this.setState({
      isMenuOpen:false
    })
    return
  }

  render() {
    const { actions, routes } = this.props;
    var current = routes[1].name
    var type = routes[1].type
    if (current == undefined) {
      current = "top"
    }
    var cl = ""
    if (this.state.isScrolled) {
      cl = "scrolled"
    }
    this.scroll()
    return (
      <header className={cl}>
        <div className="header_inner">
          <h1>
            { current == "top" ?
              <Link to={ "/" }>
                { this.state.isScrolled ?
                    <img className="small" src={logoScrolled} alt="HAKUHODO CABIN" />
                  :
                    <img className="big" src={logo} alt="HAKUHODO CABIN" />
                }
              </Link>
              :
              <Link to={ "/" }>
                { this.state.isScrolled ?
                    <img className="small" src={logoScrolled} alt="HAKUHODO CABIN" />
                  :
                    <img className="big" src={logo} alt="HAKUHODO CABIN" />
                }
              </Link>
            }
          </h1>
          { this.state.isMobile && this.state.isScrolled ?
              <div className="header__current">
                { type == "topics" ?
                    <div>(TOPICS)</div>
                  :null
                }
                { type == "member" ?
                    <div>(MEMBER)</div>
                  :null
                }
                { type == "about" ?
                    <div>(ABOUT)</div>
                  :null
                }
              </div>
            :null
          }
          { this.state.isMobile && this.state.isScrolled ?
              <div className="header__back">
                { type == "detail" ?
                    <Link to={"/" + current + "/"}><img src={backArrow} /></Link>
                  :null
                }
              </div>
            :null
          }
          { this.state.isMobile ?
            <div className="header__menu_bar">
              <a className="menu_open" onClick={this.openMenu}><span></span></a>
            </div>
          :
            <div className="header__menu">
              <div className="menu__link"><Link className={current == "topics" ? "current":""} to={ "/topics/" }>TOPICS</Link></div>
              <div className="menu__link"><Link className={current == "member" ? "current":""} to={ "/member/" }>MEMBER</Link></div>
              <div className="menu__link"><Link className={current == "about"  ? "current":""} to={ "/about/" }>ABOUT</Link></div>
            </div>
          }
        </div>
        { this.state.isMenuOpen ?
            <div className="header__mobile_menu">
              <div className="mobile_menu_inner">
                <div className="mobile_menu__header">
                  <div className="header__title"><img className="big" src={logo} alt="HAKUHODO CABIN" /></div>
                  <a className="menu_close" onClick={this.closeMenu}>CLOSE</a>
                </div>
                <div className="mobile_menu__link">
                  <div className="link"><Link className={current == "top" ? "current":""}    onClick={this.closeMenu} to={ "/" }>TOP</Link></div>
                  <div className="link"><Link className={current == "topics" ? "current":""} onClick={this.closeMenu} to={ "/topics/" }>TOPICS</Link></div>
                  <div className="link"><Link className={current == "member" ? "current":""} onClick={this.closeMenu} to={ "/member/" }>MEMBER</Link></div>
                  <div className="link"><Link className={current == "about"  ? "current":""} onClick={this.closeMenu} to={ "/about/" }>ABOUT</Link></div>
                </div>
                <div className="mobile_menu__bottom">
                  <div className="bottom__contact">
                    <a href="mailto:info@cabin.co.jp">CONTACT：info@cabin.co.jp</a>
                  </div>
                  <div className="bottom__link">
                    <ul>
                      <li><a href="https://www.hakuhodo.co.jp/privacy_policy/" target="_blank">PRIVACY POLICY</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          :null
        }
      </header>
    );
  }

  resize() {
    var w = $(window).width()
    var h = $(window).height()
    if (w < config.default.MEDIA_ALL_MOBILE) {
      if (!this.state.isMobile) {
        this.setState({ isMobile:true });
      }
    } else {
      if (this.state.isMobile) {
        this.setState({ isMobile:false });
      }
    }
  }

  scroll() {
    var w = $(window).width()
    var scrollTop = $(window).scrollTop()

    if (w < config.default.MEDIA_ALL_MOBILE) {
      $("header h1").css({
        transform:"translateY(0px)"
      })
      if (scrollTop >= 10) {
        if (!this.state.isScrolled) {
          this.setState({ isScrolled:true });
        }
      } else {
        if (this.state.isScrolled) {
          this.setState({ isScrolled:false });
        }
      }
    } else {
      var wH = $(window).height()
      var pH = $("#container").outerHeight(true)
      var rH = $("#content").outerHeight(true) + 70

      if (wH < rH && this.state.isScrolled) {
        var rs = (scrollTop / (pH - wH)) * (wH - 82)
        $("header.scrolled h1").css({
          transform:"translateY(" + rs + "px)"
        })
      } else {
        $("header h1").css({
          transform:"translateY(0px)"
        })
      }
    }

    if (wH < rH) {
      if (scrollTop >= 22) {
        if (!this.state.isScrolled) {
          this.setState({ isScrolled:true });
        }
      } else {
        if (this.state.isScrolled) {
          this.setState({ isScrolled:false });
        }
      }
    }

    if (scrollTop == 0) {
      if (this.state.isScrolled) {
        this.setState({ isScrolled:false });
      }
    }

  }
}

Header.displayName = 'Header';
Header.propTypes = {};
Header.defaultProps = {};

export default Header;



// WEBPACK FOOTER //
// ./components/Header.js